module.exports = __webpack_public_path__ + "img/shield-check-1.78ac30c3.svg";